import { UNIT_LABELS, type Unit } from '@codepass/shared';
import type { InvoiceListItem } from '@/types';

/**
 * Hvor en fakturas kunde og valuta staar.
 *
 * To kilder svarer paa `/invoices`: Codepass' egne fakturaer, hvor begge hoerer til
 * kontrakten, og fakturaer laest live fra Business Central, hvor der ingen kontrakt er og
 * begge staar paa fakturaen selv. Valget hoerer ét sted, saa to sider ikke kan vise forskellig
 * valuta paa den samme faktura.
 */

/** Kontraktens valuta, ellers fakturaens egen. DKK som sidste udkald. */
export function invoiceCurrency(invoice: InvoiceListItem): string {
  return invoice.contract?.currency ?? invoice.currency ?? 'DKK';
}

export function invoiceCustomerName(invoice: InvoiceListItem): string | null {
  return invoice.contract?.customer?.name ?? invoice.customer?.name ?? null;
}

/**
 * Enheden paa en fakturalinje, paa dansk hvor vi kender den.
 *
 * Codepass' egne linjer baerer en `Unit` - `hours`, `pcs`, `month`. En linje laest fra BC
 * baerer BC's `unitOfMeasureCode`, som er kundens eget kodeord (`TIME`, `STK`, `DAG`) og ikke
 * kan oversaettes uden et opslag i BC. Koden vises da som den staar, hvilket er bedre end det
 * `undefined` et raat opslag i UNIT_LABELS ville skrive i tabellen.
 */
export function unitLabel(unit: string): string {
  return UNIT_LABELS[unit as Unit] ?? unit;
}
